import useAxios from 'hooks/useAxios';

export async function getPurchasesByAffiliateCode(affiliateCode) {
  const api = useAxios();

  try {
    const res = await api.get(`/asset-purchase/affiliate/${affiliateCode}`);
    return res;
  } catch (err) {
    return err;
  }
}

